import { Validator } from '@vista-digital/validator';
import { FilmThumbnailMediaType, filmThumbnailMediaTypeValidator } from './media-type';
/**
 * Default configuration options for the Film Thumbnail component.
 */
export const defaultFilmThumbnailConfig = {
    mediaType: FilmThumbnailMediaType.Poster,
    showWatchlistButton: true
};
export const filmThumbnailConfigValidatorSchema = {
    mediaType: filmThumbnailMediaTypeValidator,
    showWatchlistButton: Validator.boolean()
};
export const filmThumbnailConfigValidator = Validator.object(filmThumbnailConfigValidatorSchema);
